import { useEffect, useRef, useState } from 'react';

const useDropdown = ({ onHide }) => {
  const dropdownRef = useRef();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show) {
      return undefined;
    }

    const onKeyDown = (e) => {
      if (e.keyCode === 27 || e.key === 'Escape') {
        setShow(false);

        if (typeof onHide === 'function') {
          onHide();
        }
      }
    };

    const onDocumentEvent = (e) => {
      if (!dropdownRef.current.contains(e.target)) {
        setShow(false);

        if (typeof onHide === 'function') {
          onHide();
        }
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onDocumentEvent);
    document.addEventListener('focusin', onDocumentEvent);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onDocumentEvent);
      document.removeEventListener('focusin', onDocumentEvent);
    };
  }, [show]);

  return [dropdownRef, show, setShow];
};

export default useDropdown;
